export const RESUME_TOUR = 'Resume Tour';
export const RESUME_TOUR_DESCRIPTION = 'There are still a few more things to explore, but you can resume this tour any time.';
export const TOUR_FINISH_DESCRIPTION = "You're now equipped with the tools to navigate this experience. We’re with you along the way.";
